import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class ForEachFuncStructuredStorageBaseHelper extends StructuredStorageBaseHelper {
    constructor({ handleNext, ...rest }) {
        super(rest);
        this.handleNext = handleNext;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.createIteratorStructuredStorage({ type: this.type }));
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.rawIteratorForEachFuncBase({
            hasFilter: true,
            handleNext: this.handleNext,
        }));
        if (optionsIn.pushValue) {
            sb.emitHelper(node, options, sb.helpers.wrapUndefined);
        }
    }
}

//# sourceMappingURL=ForEachFuncStructuredStorageBaseHelper.js.map
